import Ruler from '../src/Ruler';
export default Ruler;
